module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-bluegrey.f04e6dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-bluegrey.svg
// module id = bePw
// module chunks = 82